const qualificationOptions = [
	'B.A.',
	'B.Arch.',
	'B.B.A.',
	'B.B.M',
	'B.C.A.',
	'B.Com.',
	'B.D.S.',
	'B.Ed.',
	'B.E.',
	'B.F.A.',
	'B.H.M.',
	'B.Pharm.',
	'B.Plan.',
	'B.P.T.', // Bachelor of Physiotherapy
	'B.Sc.',
	'B.Tech.',
	'C.A.',
	'D.N.B.',
	'D.Pharm.',
	'Diploma',
	'L.L.B.',
	'L.L.M.',
	'M.A.',
	'M.Arch.',
	'M.B.A.',
	'M.B.B.S.',
	'M.C.A.',
	'M.Com.',
	'M.D.',
	'M.D.S.',
	'M.Ed.',
	'M.E.',
	'M.F.A.',
	'M.I.M.',
	'M.Pharm.',
	'M.Phil.',
	'M.Plan.',
	'M.P.T.', // Master of Physiotherapy
	'M.S.',
	'M.Sc.',
	'M.Tech.',
	'P.G.D.M.',
	'Ph.D.',
	'Other'
];

const occupationOptions = [
	{ label: 'Accountant', value: 'Accountant' },
	{ label: 'Actor', value: 'Actor' },
	{ label: 'Architect', value: 'Architect' },
	{ label: 'Artist', value: 'Artist' },
	{ label: 'Athlete', value: 'Athlete' },
	{ label: 'Banking', value: 'Banking' },
	{ label: 'Business', value: 'Business' },
	{ label: 'Business Analyst', value: 'Business Analyst' },
	{ label: 'Business Owner', value: 'Business Owner' },
	{ label: 'Civil Engineer', value: 'Civil Engineer' },
	{ label: 'Chef', value: 'Chef' },
	{ label: 'Coach', value: 'Coach' },
	{ label: 'Consultant', value: 'Consultant' },
	{ label: 'Construction Worker', value: 'Construction Worker' },
	{ label: 'Data Scientist', value: 'Data Scientist' },
	{ label: 'Dentist', value: 'Dentist' },
	{ label: 'Doctor', value: 'Doctor' },
	{ label: 'Driver', value: 'Driver' },
	{ label: 'Electrical Engineer', value: 'Electrical Engineer' },
	{ label: 'Entrepreneur', value: 'Entrepreneur' },
	{ label: 'Financial Advisor', value: 'Financial Advisor' },
	{ label: 'Firefighter', value: 'Firefighter' },
	{ label: 'Fitness Instructor', value: 'Fitness Instructor' },
	{ label: 'Flight Attendant', value: 'Flight Attendant' },
	{ label: 'Freelancer', value: 'Freelancer' },
	{ label: 'Graphic Designer', value: 'Graphic Designer' },
	{ label: 'HR Manager', value: 'HR Manager' },
	{ label: 'Insurance Agent', value: 'Insurance Agent' },
	{ label: 'Interior Designer', value: 'Interior Designer' },
	{ label: 'IT Engineer', value: 'IT Engineer' },
	{ label: 'Journalist', value: 'Journalist' },
	{ label: 'Lawyer', value: 'Lawyer' },
	{ label: 'Marketing Manager', value: 'Marketing Manager' },
	{ label: 'Mechanic', value: 'Mechanic' },
	{ label: 'Mechanical Engineer', value: 'Mechanical Engineer' },
	{ label: 'Musician', value: 'Musician' },
	{ label: 'NGO Worker', value: 'NGO Worker' },
	{ label: 'Nurse', value: 'Nurse' },
	{ label: 'Operations Manager', value: 'Operations Manager' },
	{ label: 'Other', value: 'Other' },
	{ label: 'Personal Trainer', value: 'Personal Trainer' },
	{ label: 'Pharmacist', value: 'Pharmacist' },
	{ label: 'PhD Student', value: 'PhD Student' },
	{ label: 'Photographer', value: 'Photographer' },
	{ label: 'Pilot', value: 'Pilot' },
	{ label: 'Police Officer', value: 'Police Officer' },
	{ label: 'Product Manager', value: 'Product Manager' },
	{ label: 'Professional', value: 'Professional' },
	{ label: 'Professor', value: 'Professor' },
	{ label: 'Real Estate Agent', value: 'Real Estate Agent' },
	{ label: 'Research Scientist', value: 'Research Scientist' },
	{ label: 'Retail Manager', value: 'Retail Manager' },
	{ label: 'Retired', value: 'Retired' },
	{ label: 'Sales Executive', value: 'Sales Executive' },
	{ label: 'Service', value: 'Service' },
	{ label: 'Social Worker', value: 'Social Worker' },
	{ label: 'Software Engineer', value: 'Software Engineer' },
	{ label: 'Student', value: 'Student' },
	{ label: 'Supply Chain Manager', value: 'Supply Chain Manager' },
	{ label: 'Teacher', value: 'Teacher' },
	{ label: 'Translator', value: 'Translator' },
	{ label: 'UX Designer', value: 'UX Designer' },
	{ label: 'Veterinarian', value: 'Veterinarian' }
  ];  
  
const rashiOptions = [
	{ value: 'Aries', label: 'Aries' },
	{ value: 'Taurus', label: 'Taurus' },
	{ value: 'Gemini', label: 'Gemini' },
	{ value: 'Cancer', label: 'Cancer' },
	{ value: 'Leo', label: 'Leo' },
	{ value: 'Virgo', label: 'Virgo' },
	{ value: 'Libra', label: 'Libra' },
	{ value: 'Scorpio', label: 'Scorpio' },
	{ value: 'Sagittarius', label: 'Sagittarius' },
	{ value: 'Capricorn', label: 'Capricorn' },
	{ value: 'Aquarius', label: 'Aquarius' },
	{ value: 'Pisces', label: 'Pisces' },
];

const annualIncomeOptions = [
	{ value: 'Less than 1 LPA', label: ' < 1 LPA ' },
	{ value: '1 LPA - 5 LPA', label: '1 LPA - 5 LPA' },
	{ value: '5 LPA - 10 LPA', label: '5 LPA - 10 LPA' },
	{ value: '10 LPA - 20 LPA', label: '10 LPA - 20 LPA' },
	{ value: 'Over 20 LPA', label: ' > 20 LPA ' },
];

const maritalStatusOptions = [
	{ value: 'Single', label: 'Single' },
	{ value: 'Divorced', label: 'Divorced' },
	{ value: 'Widowed', label: 'Widowed' },
];

const religionOptions = [
	{ value: 'Hindu', label: 'Hindu' },
	{ value: 'Muslim', label: 'Muslim' },
	{ value: 'Sikh', label: 'Sikh' },
	{ value: 'Christian', label: 'Christian' },
	{ value: 'Jain', label: 'Jain' },
	{ value: 'Parsi', label: 'Parsi' },
	{ value: 'Buddhist', label: 'Buddhist' },
	{ value: 'Others', label: 'Others' },
];

const languageOptions = [
	'Konkani (कोंकणी)',
	'Assamese (অসমীয়া)',
	'Benagali (बेंगाली)',
	'English (English)',
	'Gujarati (ગુજરાતી)',
	'Hindi (हिन्दी)',
	'Jain (ज़िन)',
	'Kannada (ಕನ್ನಡ)',
	'Kashmiri (कश्मीरी)',
	'Malayalam (മലയാളം)',
	'Marathi (मराठी)',
	'Marwari (मरावरी)',
	'Punjabi (ਪੰਜਾਬੀ)',
	'Rajasthani (राजस्थानी)',
	'Savaji (सवाजी)',
	'Tamil (தமிழ்)',
	'Telugu (తెలుగు)',
	'Others'
];

const motherTongueOptions = () => {
	return languageOptions.map(language => {
		// Extract the value from the label (everything before the space)
		const value = language.split(' ')[0];
		// Create an object with value and label
		return { value, label: language };
	});
}

const bloodGroupOptions = [
	{ value: 'A+', label: 'A+' },
	{ value: 'A-', label: 'A-' },
	{ value: 'B+', label: 'B+' },
	{ value: 'B-', label: 'B-' },
	{ value: 'AB+', label: 'AB+' },
	{ value: 'AB-', label: 'AB-' },
	{ value: 'O+', label: 'O+' },
	{ value: 'O-', label: 'O-' },
	{ value: 'Other', label: 'Other' },
];

const drinkingHabitsOptions = [
	{ value: 'Yes', label: 'Yes' },
	{ value: 'No', label: 'No' },
	{ value: 'Occassionally', label: 'Occassionally' },
];

const smokingHabitsOptions = [
	{ value: 'Yes', label: 'Yes' },
	{ value: 'No', label: 'No' },
	{ value: 'Occassionally', label: 'Occassionally' },
];

const heightOptions = [
	{ value: '4 feet', label: '4 feet' },
	{ value: '4 feet and 1 inch', label: '4 feet and 1 inch' },
	{ value: '4 feet and 2 inches', label: '4 feet and 2 inches' },
	{ value: '4 feet and 3 inches', label: '4 feet and 3 inches' },
	{ value: '4 feet and 4 inches', label: '4 feet and 4 inches' },
	{ value: '4 feet and 5 inches', label: '4 feet and 5 inches' },
	{ value: '4 feet and 6 inches', label: '4 feet and 6 inches' },
	{ value: '4 feet and 7 inches', label: '4 feet and 7 inches' },
	{ value: '4 feet and 8 inches', label: '4 feet and 8 inches' },
	{ value: '4 feet and 9 inches', label: '4 feet and 9 inches' },
	{ value: '4 feet and 10 inches', label: '4 feet and 10 inches' },
	{ value: '4 feet and 11 inches', label: '4 feet and 11 inches' },
	{ value: '5 feet', label: '5 feet' },
	{ value: '5 feet and 1 inch', label: '5 feet and 1 inch' },
	{ value: '5 feet and 2 inches', label: '5 feet and 2 inches' },
	{ value: '5 feet and 3 inches', label: '5 feet and 3 inches' },
	{ value: '5 feet and 4 inches', label: '5 feet and 4 inches' },
	{ value: '5 feet and 5 inches', label: '5 feet and 5 inches' },
	{ value: '5 feet and 6 inches', label: '5 feet and 6 inches' },
	{ value: '5 feet and 7 inches', label: '5 feet and 7 inches' },
	{ value: '5 feet and 8 inches', label: '5 feet and 8 inches' },
	{ value: '5 feet and 9 inches', label: '5 feet and 9 inches' },
	{ value: '5 feet and 10 inches', label: '5 feet and 10 inches' },
	{ value: '5 feet and 11 inches', label: '5 feet and 11 inches' },
	{ value: '6 feet', label: '6 feet' },
	{ value: '6 feet and 1 inch', label: '6 feet and 1 inch' },
	{ value: '6 feet and 2 inches', label: '6 feet and 2 inches' },
	{ value: '6 feet and 3 inches', label: '6 feet and 3 inches' },
	{ value: '6 feet and 4 inches', label: '6 feet and 4 inches' },
	{ value: '6 feet and 5 inches', label: '6 feet and 5 inches' },
	{ value: '6 feet and 6 inches', label: '6 feet and 6 inches' },
	{ value: '6 feet and 7 inches', label: '6 feet and 7 inches' },
	{ value: '6 feet and 8 inches', label: '6 feet and 8 inches' },
	{ value: '6 feet and 9 inches', label: '6 feet and 9 inches' },
	{ value: '6 feet and 10 inches', label: '6 feet and 10 inches' },
	{ value: '6 feet and 11 inches', label: '6 feet and 11 inches' },
	{ value: '7 feet', label: '7 feet' },
	{ value: '7 feet and 1 inch', label: '7 feet and 1 inch' },
	{ value: '7 feet and 2 inches', label: '7 feet and 2 inches' },
	{ value: '7 feet and 3 inches', label: '7 feet and 3 inches' },
	{ value: '7 feet and 4 inches', label: '7 feet and 4 inches' },
	{ value: '7 feet and 5 inches', label: '7 feet and 5 inches' },
	{ value: '7 feet and 6 inches', label: '7 feet and 6 inches' },
	{ value: '7 feet and 7 inches', label: '7 feet and 7 inches' },
	{ value: '7 feet and 8 inches', label: '7 feet and 8 inches' },
	{ value: '7 feet and 9 inches', label: '7 feet and 9 inches' },
	{ value: '7 feet and 10 inches', label: '7 feet and 10 inches' },
	{ value: '7 feet and 11 inches', label: '7 feet and 11 inches' },
	{ value: '8 feet', label: '8 feet' },
];

const feetOptions = [
	// { label: '2 feet', value: 2 },
	{ label: '3 feet', value: 3 },
	{ label: '4 feet', value: 4 },
	{ label: '5 feet', value: 5 },
	{ label: '6 feet', value: 6 },
	{ label: '7 feet', value: 7 },
	// { label: '8 feet', value: 8 },
	// { label: '9 feet', value: 9 },
	// { label: '10 feet', value: 10 },
];
const inchOptions = [
	{ label: '0 inch', value: 0 },
	{ label: '1 inch', value: 1 },
	{ label: '2 inches', value: 2 },
	{ label: '3 inches', value: 3 },
	{ label: '4 inches', value: 4 },
	{ label: '5 inches', value: 5 },
	{ label: '6 inches', value: 6 },
	{ label: '7 inches', value: 7 },
	{ label: '8 inches', value: 8 },
	{ label: '9 inches', value: 9 },
	{ label: '10 inches', value: 10 },
	{ label: '11 inches', value: 11 },
];

const foodHabitsOptions = [
	{ value: 'Eggetarian', label: 'Eggetarian' },
	{ value: 'Jain', label: 'Jain' },
	{ value: 'Non-Vegetarian', label: 'Non-Vegetarian' },
	{ value: 'Vegan', label: 'Vegan' },
	{ value: 'Vegetarian', label: 'Vegetarian' },
	{ value: 'Pescetarian', label: 'Pescetarian' },
	{ value: 'Other', label: 'Other' },
];

export const genderOptions = [
	{
		value: 'male',
		label: 'Male',
	},
	{
		value: 'female',
		label: 'Female',
	},
	// {
	// 	value: 'others',
	// 	label: 'Other',
	// },
];

const casteOptions = [
	{ value: 'GSB', label: 'GSB' },
	{ value: 'CSB', label: 'CSB' },
	{ value: 'Kudaldeshkar', label: 'Kudaldeshkar' },
	{ value: 'RSB', label: 'RSB' },
	{ value: 'Others', label: 'Others' },
];

const nakshatraOptions = [
	{ value: 'Ashwini', label: 'Ashwini (Dev)' },
	{ value: 'Bharani', label: 'Bharani (Manushya)' },
	{ value: 'Kritika', label: 'Kritika (Rakshasa)' },
	{ value: 'Rohini', label: 'Rohini (Manushya)' },
	{ value: 'Mrigashira', label: 'Mrigashira (Dev)' },
	{ value: 'Ardra', label: 'Ardra (Nakshatra)' },
	{ value: 'Punarvasu', label: 'Punarvasu (Dev)' },
	{ value: 'Pushya', label: 'Pushya (Dev)' },
	{ value: 'Ashlesha', label: 'Ashlesha (Rakshas)' },
	{ value: 'Magh', label: 'Magh (Rakshasa)' },
	{ value: 'Purva Phalguni', label: 'Purva Phalguni (Manushya)' },
	{ value: 'Uttar Phalguni', label: 'Uttar Phalguni' },
	{ value: 'Hasta', label: 'Hasta (Dev)' },
	{ value: 'Chitra', label: 'Chitra (Rakshas)' },
	{ value: 'Swati', label: 'Swati (Dev)' },
	{ value: 'Vishakha', label: 'Vishakha (Rakshasa)' },
	{ value: 'Anuradha', label: 'Anuradha (Dev)' },
	{ value: 'Jyestha', label: 'Jyestha (Rakshas)' },
	{ value: 'Moola ', label: 'Moola (Rakshasa)' },
	{ value: 'Poorva Ashadha', label: 'Poorva Ashadha (Manushya)' },
	{ value: 'Uttar Ashadha', label: 'Uttar Ashadha (Manushya)' },
	{ value: 'Shravan', label: 'Shravan (Dev)' },
	{ value: 'Dhanishta', label: 'Dhanishta (Rakshasa)' },
	{ value: 'Shatabhisha', label: 'Shatabhisha (Rakshasa)' },
	{ value: 'Poorva Bhadra', label: 'Poorva Bhadra (Manushya)' },
	{ value: 'Uttar Bhadra', label: 'Uttar Bhadra (Manushya)' },
	{ value: 'Uttara', label: 'Uttara' },
	{ value: 'Hubba', label: 'Hubba' },
	{ value: 'Revati', label: 'Revati (Dev)' },
];

const gotraOptions = [
	{ value: 'Atri', label: 'Atri' },
	{ value: 'Bharadwaja', label: 'Bharadwaja' },
	{ value: 'Gautama', label: 'Gautama' },
	{ value: 'Gargya', label: 'Gargya' },
	{ value: 'Jamadagni', label: 'Jamadagni' },
	{ value: 'Kashyapa', label: 'Kashyapa' },
	{ value: 'Kaushika', label: 'Kaushika' },
	{ value: 'Kaunsha', label: 'Kaunsha' },
	{ value: 'Koundinya', label: 'Koundinya' },
	{ value: 'Vatsa', label: 'Vatsa' },
	{ value: 'Vasista', label: 'Vasista' },
	{ value: 'Vishwamitra', label: 'Vishwamitra' },
	{ value: 'Other', label: 'Other' },
];

const kuldevataOptions = [
	{ value: 'Shri Aryadurga', label: 'Shri Aryadurga' },
	{ value: 'Shri Aryadurga Damodar', label: 'Shri Aryadurga Damodar' },
	{ value: 'Shri Bindu Mahadev', label: 'Shri Bindu Mahadev' },
	{ value: 'Shri Damodar', label: 'Shri Damodar' },
	{
		value: 'Shri Devaki Krishna Ravalnath',
		label: 'Shri Devaki Krishna Ravalnath',
	},
	{ value: 'Shri Ganapati Ravalnath Mahamaya', label: 'Shri Ganapati Ravalnath Mahamaya' },
	{ value: 'Shri Kamakshi', label: 'Shri Kamakshi' },
	{ value: 'Shri Katyayeni Baneshwar', label: 'Shri Katyayeni Baneshwar' },
	{ value: 'Shri Lakshmi Narayan', label: 'Shri Lakshmi Narayan' },
	{ value: 'Shri Lakshmi Narasimha', label: 'Shri Lakshmi Narasimha' },
	{ value: 'Shri Lakshmi Ravalnath', label: 'Shri Lakshmi Ravalnath' },
	{ value: 'Shri Maha Ganapathi', label: 'Shri Maha Ganapathi' },
	{ value: 'Shri Maha Ganapathi Mahamaya', label: 'Shri Maha Ganapathi Mahamaya' },
	{ value: 'Shri Mahalakshmi', label: 'Shri Mahalakshmi' },
	{ value: 'Shri Mahalasa Narayani', label: 'Shri Mahalasa Narayani' },
	{ value: 'Shri Mahamaya', label: 'Shri Mahamaya' },
	{ value: 'Shri Mangeshi', label: 'Shri Mangeshi' },
	{ value: 'Shri Mangeshi Mahalakshmi', label: 'Shri Mangeshi Mahalakshmi' },
	{ value: 'Shri Nagesh', label: 'Shri Nagesh' },
	{ value: 'Shri Nagesh Mahalakshmi', label: 'Shri Nagesh Mahalakshmi' },
	{ value: 'Shri Navadurga', label: 'Shri Navadurga' },
	{ value: 'Shri Ramnath', label: 'Shri Ramnath' },
	{
		value: 'Shri Ramanath Shanteri Kamakshi',
		label: 'Shri Ramanath Shanteri Kamakshi',
	},
	{ value: 'Shri Saptkotishwar', label: 'Shri Saptkotishwar' },
	{ value: 'Shri Shantadurga', label: 'Shri Shantadurga' },
	{ value: 'Shri Shiroda Kamakshi', label: 'Shri Shiroda Kamakshi' },
	{ value: 'Shri Vijaydurga', label: 'Shri Vijaydurga' },
	{ value: 'Shri Vimlesh', label: 'Shri Vimlesh' },
	{ value: 'Other', label: 'Other' },
];

const complexionOptions = [
	{ value: 'ExtremelyFair', label: 'Extremely fair ' },
	{ value: 'Fair', label: 'Fair ' },
	{ value: 'Medium', label: 'Medium ' },
	{ value: 'Olive', label: 'Olive ' },
	{ value: 'Brown', label: 'Brown ' },
	{ value: 'Dark', label: 'Dark ' },
];

const rashiHindiOptions = [
	{ value: 'Mesh', label: 'Mesh (मेष)' },
	{ value: 'Vrishabh', label: 'Vrishabh (वृषभ)' },
	{ value: 'Mithun', label: 'Mithun (मिथुन)' },
	{ value: 'Kark', label: 'Kark (कर्क)' },
	{ value: 'Sinh', label: 'Sinh (सिंह)' },
	{ value: 'Kanya', label: 'Kanya (कन्या)' },
	{ value: 'Tula', label: 'Tula (तुला)' },
	{ value: 'Vrishchik', label: 'Vrishchik (वृश्चिक)' },
	{ value: 'Dhanu', label: 'Dhanu (धनु)' },
	{ value: 'Makar', label: 'Makar (मकर)' },
	{ value: 'Kumbh', label: 'Kumbh (कुम्भ)' },
	{ value: 'Meen', label: 'Meen (मीन)' },
	{ value: 'Others', label: 'Others' }
];

const stateOptions = [
	{ value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
	{ value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
	{ value: 'Assam', label: 'Assam' },
	{ value: 'Bihar', label: 'Bihar' },
	{ value: 'Chhattisgarh', label: 'Chhattisgarh' },
	{ value: 'Goa', label: 'Goa' },
	{ value: 'Gujarat', label: 'Gujarat' },
	{ value: 'Haryana', label: 'Haryana' },
	{ value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
	{ value: 'Jharkhand', label: 'Jharkhand' },
	{ value: 'Karnataka', label: 'Karnataka' },
	{ value: 'Kerala', label: 'Kerala' },
	{ value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
	{ value: 'Maharashtra', label: 'Maharashtra' },
	{ value: 'Manipur', label: 'Manipur' },
	{ value: 'Meghalaya', label: 'Meghalaya' },
	{ value: 'Mizoram', label: 'Mizoram' },
	{ value: 'Nagaland', label: 'Nagaland' },
	{ value: 'Odisha', label: 'Odisha' },
	{ value: 'Punjab', label: 'Punjab' },
	{ value: 'Rajasthan', label: 'Rajasthan' },
	{ value: 'Sikkim', label: 'Sikkim' },
	{ value: 'Tamil Nadu', label: 'Tamil Nadu' },
	{ value: 'Telangana', label: 'Telangana' },
	{ value: 'Tripura', label: 'Tripura' },
	{ value: 'Uttarakhand', label: 'Uttarakhand' },
	{ value: 'West Bengal', label: 'West Bengal' },
	{
		value: 'Andaman and Nicobar Islands',
		label: 'Andaman and Nicobar Islands',
	},
	{ value: 'Chandigarh', label: 'Chandigarh' },
	{
		value: 'Dadar and Nagar Haveli and Daman and Diu',
		label: 'Dadar and Nagar Haveli and Daman and Diu',
	},
	{ value: 'Delhi', label: 'Delhi' },
	{ value: 'Jammu and Kashmir', label: 'Jammu and Kashmir' },
	{ value: 'Ladakh', label: 'Ladakh' },
	{ value: 'Lakshwadeep', label: 'Lakshwadeep' },
	{ value: 'Puducherry', label: 'Puducherry' },
	{ value: 'Other', label: 'Other' },
];

const countryOptions = [
	{
		value: 'India',
		dialCode: 91,
		code: 'IN',
		label: 'India (IN)',
		countryWithCode: 'India (IN) - 91',
	},
	{
		value: 'Afghanistan',
		dialCode: 93,
		code: 'AF',
		label: 'Afghanistan (AF)',
		countryWithCode: 'Afghanistan (AF) - 93',
	},
	{
		value: 'Aland Islands',
		dialCode: 358,
		code: 'AX',
		label: 'Aland Islands (AX)',
		countryWithCode: 'Aland Islands (AX) - 358',
	},
	{
		value: 'Albania',
		dialCode: 355,
		code: 'AL',
		label: 'Albania (AL)',
		countryWithCode: 'Albania (AL) - 355',
	},
	{
		value: 'Algeria',
		dialCode: 213,
		code: 'DZ',
		label: 'Algeria (DZ)',
		countryWithCode: 'Algeria (DZ) - 213',
	},
	{
		value: 'AmericanSamoa',
		dialCode: 1684,
		code: 'AS',
		label: 'AmericanSamoa (AS)',
		countryWithCode: 'AmericanSamoa (AS) - 1684',
	},
	{
		value: 'Andorra',
		dialCode: 376,
		code: 'AD',
		label: 'Andorra (AD)',
		countryWithCode: 'Andorra (AD) - 376',
	},
	{
		value: 'Angola',
		dialCode: 244,
		code: 'AO',
		label: 'Angola (AO)',
		countryWithCode: 'Angola (AO) - 244',
	},
	{
		value: 'Anguilla',
		dialCode: 1264,
		code: 'AI',
		label: 'Anguilla (AI)',
		countryWithCode: 'Anguilla (AI) - 1264',
	},
	{
		value: 'Antarctica',
		dialCode: 672,
		code: 'AQ',
		label: 'Antarctica (AQ)',
		countryWithCode: 'Antarctica (AQ) - 672',
	},
	{
		value: 'Antigua and Barbuda',
		dialCode: 1268,
		code: 'AG',
		label: 'Antigua and Barbuda (AG)',
		countryWithCode: 'Antigua and Barbuda (AG) - 1268',
	},
	{
		value: 'Argentina',
		dialCode: 54,
		code: 'AR',
		label: 'Argentina (AR)',
		countryWithCode: 'Argentina (AR) - 54',
	},
	{
		value: 'Armenia',
		dialCode: 374,
		code: 'AM',
		label: 'Armenia (AM)',
		countryWithCode: 'Armenia (AM) - 374',
	},
	{
		value: 'Aruba',
		dialCode: 297,
		code: 'AW',
		label: 'Aruba (AW)',
		countryWithCode: 'Aruba (AW) - 297',
	},
	{
		value: 'Australia',
		dialCode: 61,
		code: 'AU',
		label: 'Australia (AU)',
		countryWithCode: 'Australia (AU) - 61',
	},
	{
		value: 'Austria',
		dialCode: 43,
		code: 'AT',
		label: 'Austria (AT)',
		countryWithCode: 'Austria (AT) - 43',
	},
	{
		value: 'Azerbaijan',
		dialCode: 994,
		code: 'AZ',
		label: 'Azerbaijan (AZ)',
		countryWithCode: 'Azerbaijan (AZ) - 994',
	},
	{
		value: 'Bahamas',
		dialCode: 1242,
		code: 'BS',
		label: 'Bahamas (BS)',
		countryWithCode: 'Bahamas (BS) - 1242',
	},
	{
		value: 'Bahrain',
		dialCode: 973,
		code: 'BH',
		label: 'Bahrain (BH)',
		countryWithCode: 'Bahrain (BH) - 973',
	},
	{
		value: 'Bangladesh',
		dialCode: 880,
		code: 'BD',
		label: 'Bangladesh (BD)',
		countryWithCode: 'Bangladesh (BD) - 880',
	},
	{
		value: 'Barbados',
		dialCode: 1246,
		code: 'BB',
		label: 'Barbados (BB)',
		countryWithCode: 'Barbados (BB) - 1246',
	},
	{
		value: 'Belarus',
		dialCode: 375,
		code: 'BY',
		label: 'Belarus (BY)',
		countryWithCode: 'Belarus (BY) - 375',
	},
	{
		value: 'Belgium',
		dialCode: 32,
		code: 'BE',
		label: 'Belgium (BE)',
		countryWithCode: 'Belgium (BE) - 32',
	},
	{
		value: 'Belize',
		dialCode: 501,
		code: 'BZ',
		label: 'Belize (BZ)',
		countryWithCode: 'Belize (BZ) - 501',
	},
	{
		value: 'Benin',
		dialCode: 229,
		code: 'BJ',
		label: 'Benin (BJ)',
		countryWithCode: 'Benin (BJ) - 229',
	},
	{
		value: 'Bermuda',
		dialCode: 1441,
		code: 'BM',
		label: 'Bermuda (BM)',
		countryWithCode: 'Bermuda (BM) - 1441',
	},
	{
		value: 'Bhutan',
		dialCode: 975,
		code: 'BT',
		label: 'Bhutan (BT)',
		countryWithCode: 'Bhutan (BT) - 975',
	},
	{
		value: 'Bolivia, Plurinational State of',
		dialCode: 591,
		code: 'BO',
		label: 'Bolivia, Plurinational State of (BO)',
		countryWithCode: 'Bolivia, Plurinational State of (BO) - 591',
	},
	{
		value: 'Bosnia and Herzegovina',
		dialCode: 387,
		code: 'BA',
		label: 'Bosnia and Herzegovina (BA)',
		countryWithCode: 'Bosnia and Herzegovina (BA) - 387',
	},
	{
		value: 'Botswana',
		dialCode: 267,
		code: 'BW',
		label: 'Botswana (BW)',
		countryWithCode: 'Botswana (BW) - 267',
	},
	{
		value: 'Brazil',
		dialCode: 55,
		code: 'BR',
		label: 'Brazil (BR)',
		countryWithCode: 'Brazil (BR) - 55',
	},
	{
		value: 'British Indian Ocean Territory',
		dialCode: 246,
		code: 'IO',
		label: 'British Indian Ocean Territory (IO)',
		countryWithCode: 'British Indian Ocean Territory (IO) - 246',
	},
	{
		value: 'Brunei Darussalam',
		dialCode: 673,
		code: 'BN',
		label: 'Brunei Darussalam (BN)',
		countryWithCode: 'Brunei Darussalam (BN) - 673',
	},
	{
		value: 'Bulgaria',
		dialCode: 359,
		code: 'BG',
		label: 'Bulgaria (BG)',
		countryWithCode: 'Bulgaria (BG) - 359',
	},
	{
		value: 'Burkina Faso',
		dialCode: 226,
		code: 'BF',
		label: 'Burkina Faso (BF)',
		countryWithCode: 'Burkina Faso (BF) - 226',
	},
	{
		value: 'Burundi',
		dialCode: 257,
		code: 'BI',
		label: 'Burundi (BI)',
		countryWithCode: 'Burundi (BI) - 257',
	},
	{
		value: 'Cambodia',
		dialCode: 855,
		code: 'KH',
		label: 'Cambodia (KH)',
		countryWithCode: 'Cambodia (KH) - 855',
	},
	{
		value: 'Cameroon',
		dialCode: 237,
		code: 'CM',
		label: 'Cameroon (CM)',
		countryWithCode: 'Cameroon (CM) - 237',
	},
	{
		value: 'Canada',
		dialCode: 1,
		code: 'CA',
		label: 'Canada (CA)',
		countryWithCode: 'Canada (CA) - 1',
	},
	{
		value: 'Cape Verde',
		dialCode: 238,
		code: 'CV',
		label: 'Cape Verde (CV)',
		countryWithCode: 'Cape Verde (CV) - 238',
	},
	{
		value: 'Cayman Islands',
		dialCode: 345,
		code: 'KY',
		label: 'Cayman Islands (KY)',
		countryWithCode: 'Cayman Islands (KY) - 345',
	},
	{
		value: 'Central African Republic',
		dialCode: 236,
		code: 'CF',
		label: 'Central African Republic (CF)',
		countryWithCode: 'Central African Republic (CF) - 236',
	},
	{
		value: 'Chad',
		dialCode: 235,
		code: 'TD',
		label: 'Chad (TD)',
		countryWithCode: 'Chad (TD) - 235',
	},
	{
		value: 'Chile',
		dialCode: 56,
		code: 'CL',
		label: 'Chile (CL)',
		countryWithCode: 'Chile (CL) - 56',
	},
	{
		value: 'China',
		dialCode: 86,
		code: 'CN',
		label: 'China (CN)',
		countryWithCode: 'China (CN) - 86',
	},
	{
		value: 'Christmas Island',
		dialCode: 61,
		code: 'CX',
		label: 'Christmas Island (CX)',
		countryWithCode: 'Christmas Island (CX) - 61',
	},
	{
		value: 'Cocos (Keeling) Islands',
		dialCode: 61,
		code: 'CC',
		label: 'Cocos (Keeling) Islands (CC)',
		countryWithCode: 'Cocos (Keeling) Islands (CC) - 61',
	},
	{
		value: 'Colombia',
		dialCode: 57,
		code: 'CO',
		label: 'Colombia (CO)',
		countryWithCode: 'Colombia (CO) - 57',
	},
	{
		value: 'Comoros',
		dialCode: 269,
		code: 'KM',
		label: 'Comoros (KM)',
		countryWithCode: 'Comoros (KM) - 269',
	},
	{
		value: 'Congo',
		dialCode: 242,
		code: 'CG',
		label: 'Congo (CG)',
		countryWithCode: 'Congo (CG) - 242',
	},
	{
		value: 'Congo, The Democratic Republic of the Congo',
		dialCode: 243,
		code: 'CD',
		label: 'Congo, The Democratic Republic of the Congo (CD)',
		countryWithCode:
			'Congo, The Democratic Republic of the Congo (CD) - 243',
	},
	{
		value: 'Cook Islands',
		dialCode: 682,
		code: 'CK',
		label: 'Cook Islands (CK)',
		countryWithCode: 'Cook Islands (CK) - 682',
	},
	{
		value: 'Costa Rica',
		dialCode: 506,
		code: 'CR',
		label: 'Costa Rica (CR)',
		countryWithCode: 'Costa Rica (CR) - 506',
	},
	{
		value: "Cote d'Ivoire",
		dialCode: 225,
		code: 'CI',
		label: "Cote d'Ivoire (CI)",
		countryWithCode: "Cote d'Ivoire (CI) - 225",
	},
	{
		value: 'Croatia',
		dialCode: 385,
		code: 'HR',
		label: 'Croatia (HR)',
		countryWithCode: 'Croatia (HR) - 385',
	},
	{
		value: 'Cuba',
		dialCode: 53,
		code: 'CU',
		label: 'Cuba (CU)',
		countryWithCode: 'Cuba (CU) - 53',
	},
	{
		value: 'Cyprus',
		dialCode: 357,
		code: 'CY',
		label: 'Cyprus (CY)',
		countryWithCode: 'Cyprus (CY) - 357',
	},
	{
		value: 'Czech Republic',
		dialCode: 420,
		code: 'CZ',
		label: 'Czech Republic (CZ)',
		countryWithCode: 'Czech Republic (CZ) - 420',
	},
	{
		value: 'Denmark',
		dialCode: 45,
		code: 'DK',
		label: 'Denmark (DK)',
		countryWithCode: 'Denmark (DK) - 45',
	},
	{
		value: 'Djibouti',
		dialCode: 253,
		code: 'DJ',
		label: 'Djibouti (DJ)',
		countryWithCode: 'Djibouti (DJ) - 253',
	},
	{
		value: 'Dominica',
		dialCode: 1767,
		code: 'DM',
		label: 'Dominica (DM)',
		countryWithCode: 'Dominica (DM) - 1767',
	},
	{
		value: 'Dominican Republic',
		dialCode: 1849,
		code: 'DO',
		label: 'Dominican Republic (DO)',
		countryWithCode: 'Dominican Republic (DO) - 1849',
	},
	{
		value: 'Ecuador',
		dialCode: 593,
		code: 'EC',
		label: 'Ecuador (EC)',
		countryWithCode: 'Ecuador (EC) - 593',
	},
	{
		value: 'Egypt',
		dialCode: 20,
		code: 'EG',
		label: 'Egypt (EG)',
		countryWithCode: 'Egypt (EG) - 20',
	},
	{
		value: 'El Salvador',
		dialCode: 503,
		code: 'SV',
		label: 'El Salvador (SV)',
		countryWithCode: 'El Salvador (SV) - 503',
	},
	{
		value: 'Equatorial Guinea',
		dialCode: 240,
		code: 'GQ',
		label: 'Equatorial Guinea (GQ)',
		countryWithCode: 'Equatorial Guinea (GQ) - 240',
	},
	{
		value: 'Eritrea',
		dialCode: 291,
		code: 'ER',
		label: 'Eritrea (ER)',
		countryWithCode: 'Eritrea (ER) - 291',
	},
	{
		value: 'Estonia',
		dialCode: 372,
		code: 'EE',
		label: 'Estonia (EE)',
		countryWithCode: 'Estonia (EE) - 372',
	},
	{
		value: 'Ethiopia',
		dialCode: 251,
		code: 'ET',
		label: 'Ethiopia (ET)',
		countryWithCode: 'Ethiopia (ET) - 251',
	},
	{
		value: 'Falkland Islands (Malvinas)',
		dialCode: 500,
		code: 'FK',
		label: 'Falkland Islands (Malvinas) (FK)',
		countryWithCode: 'Falkland Islands (Malvinas) (FK) - 500',
	},
	{
		value: 'Faroe Islands',
		dialCode: 298,
		code: 'FO',
		label: 'Faroe Islands (FO)',
		countryWithCode: 'Faroe Islands (FO) - 298',
	},
	{
		value: 'Fiji',
		dialCode: 679,
		code: 'FJ',
		label: 'Fiji (FJ)',
		countryWithCode: 'Fiji (FJ) - 679',
	},
	{
		value: 'Finland',
		dialCode: 358,
		code: 'FI',
		label: 'Finland (FI)',
		countryWithCode: 'Finland (FI) - 358',
	},
	{
		value: 'France',
		dialCode: 33,
		code: 'FR',
		label: 'France (FR)',
		countryWithCode: 'France (FR) - 33',
	},
	{
		value: 'French Guiana',
		dialCode: 594,
		code: 'GF',
		label: 'French Guiana (GF)',
		countryWithCode: 'French Guiana (GF) - 594',
	},
	{
		value: 'French Polynesia',
		dialCode: 689,
		code: 'PF',
		label: 'French Polynesia (PF)',
		countryWithCode: 'French Polynesia (PF) - 689',
	},
	{
		value: 'Gabon',
		dialCode: 241,
		code: 'GA',
		label: 'Gabon (GA)',
		countryWithCode: 'Gabon (GA) - 241',
	},
	{
		value: 'Gambia',
		dialCode: 220,
		code: 'GM',
		label: 'Gambia (GM)',
		countryWithCode: 'Gambia (GM) - 220',
	},
	{
		value: 'Georgia',
		dialCode: 995,
		code: 'GE',
		label: 'Georgia (GE)',
		countryWithCode: 'Georgia (GE) - 995',
	},
	{
		value: 'Germany',
		dialCode: 49,
		code: 'DE',
		label: 'Germany (DE)',
		countryWithCode: 'Germany (DE) - 49',
	},
	{
		value: 'Ghana',
		dialCode: 233,
		code: 'GH',
		label: 'Ghana (GH)',
		countryWithCode: 'Ghana (GH) - 233',
	},
	{
		value: 'Gibraltar',
		dialCode: 350,
		code: 'GI',
		label: 'Gibraltar (GI)',
		countryWithCode: 'Gibraltar (GI) - 350',
	},
	{
		value: 'Greece',
		dialCode: 30,
		code: 'GR',
		label: 'Greece (GR)',
		countryWithCode: 'Greece (GR) - 30',
	},
	{
		value: 'Greenland',
		dialCode: 299,
		code: 'GL',
		label: 'Greenland (GL)',
		countryWithCode: 'Greenland (GL) - 299',
	},
	{
		value: 'Grenada',
		dialCode: 1473,
		code: 'GD',
		label: 'Grenada (GD)',
		countryWithCode: 'Grenada (GD) - 1473',
	},
	{
		value: 'Guadeloupe',
		dialCode: 590,
		code: 'GP',
		label: 'Guadeloupe (GP)',
		countryWithCode: 'Guadeloupe (GP) - 590',
	},
	{
		value: 'Guam',
		dialCode: 1671,
		code: 'GU',
		label: 'Guam (GU)',
		countryWithCode: 'Guam (GU) - 1671',
	},
	{
		value: 'Guatemala',
		dialCode: 502,
		code: 'GT',
		label: 'Guatemala (GT)',
		countryWithCode: 'Guatemala (GT) - 502',
	},
	{
		value: 'Guernsey',
		dialCode: 44,
		code: 'GG',
		label: 'Guernsey (GG)',
		countryWithCode: 'Guernsey (GG) - 44',
	},
	{
		value: 'Guinea',
		dialCode: 224,
		code: 'GN',
		label: 'Guinea (GN)',
		countryWithCode: 'Guinea (GN) - 224',
	},
	{
		value: 'Guinea-Bissau',
		dialCode: 245,
		code: 'GW',
		label: 'Guinea-Bissau (GW)',
		countryWithCode: 'Guinea-Bissau (GW) - 245',
	},
	{
		value: 'Guyana',
		dialCode: 595,
		code: 'GY',
		label: 'Guyana (GY)',
		countryWithCode: 'Guyana (GY) - 595',
	},
	{
		value: 'Haiti',
		dialCode: 509,
		code: 'HT',
		label: 'Haiti (HT)',
		countryWithCode: 'Haiti (HT) - 509',
	},
	{
		value: 'Holy See (Vatican City State)',
		dialCode: 379,
		code: 'VA',
		label: 'Holy See (Vatican City State) (VA)',
		countryWithCode: 'Holy See (Vatican City State) (VA) - 379',
	},
	{
		value: 'Honduras',
		dialCode: 504,
		code: 'HN',
		label: 'Honduras (HN)',
		countryWithCode: 'Honduras (HN) - 504',
	},
	{
		value: 'Hong Kong',
		dialCode: 852,
		code: 'HK',
		label: 'Hong Kong (HK)',
		countryWithCode: 'Hong Kong (HK) - 852',
	},
	{
		value: 'Hungary',
		dialCode: 36,
		code: 'HU',
		label: 'Hungary (HU)',
		countryWithCode: 'Hungary (HU) - 36',
	},
	{
		value: 'Iceland',
		dialCode: 354,
		code: 'IS',
		label: 'Iceland (IS)',
		countryWithCode: 'Iceland (IS) - 354',
	},
	{
		value: 'Indonesia',
		dialCode: 62,
		code: 'ID',
		label: 'Indonesia (ID)',
		countryWithCode: 'Indonesia (ID) - 62',
	},
	{
		value: 'Iran, Islamic Republic of Persian Gulf',
		dialCode: 98,
		code: 'IR',
		label: 'Iran, Islamic Republic of Persian Gulf (IR)',
		countryWithCode: 'Iran, Islamic Republic of Persian Gulf (IR) - 98',
	},
	{
		value: 'Iraq',
		dialCode: 964,
		code: 'IQ',
		label: 'Iraq (IQ)',
		countryWithCode: 'Iraq (IQ) - 964',
	},
	{
		value: 'Ireland',
		dialCode: 353,
		code: 'IE',
		label: 'Ireland (IE)',
		countryWithCode: 'Ireland (IE) - 353',
	},
	{
		value: 'Isle of Man',
		dialCode: 44,
		code: 'IM',
		label: 'Isle of Man (IM)',
		countryWithCode: 'Isle of Man (IM) - 44',
	},
	{
		value: 'Israel',
		dialCode: 972,
		code: 'IL',
		label: 'Israel (IL)',
		countryWithCode: 'Israel (IL) - 972',
	},
	{
		value: 'Italy',
		dialCode: 39,
		code: 'IT',
		label: 'Italy (IT)',
		countryWithCode: 'Italy (IT) - 39',
	},
	{
		value: 'Jamaica',
		dialCode: 1876,
		code: 'JM',
		label: 'Jamaica (JM)',
		countryWithCode: 'Jamaica (JM) - 1876',
	},
	{
		value: 'Japan',
		dialCode: 81,
		code: 'JP',
		label: 'Japan (JP)',
		countryWithCode: 'Japan (JP) - 81',
	},
	{
		value: 'Jersey',
		dialCode: 44,
		code: 'JE',
		label: 'Jersey (JE)',
		countryWithCode: 'Jersey (JE) - 44',
	},
	{
		value: 'Jordan',
		dialCode: 962,
		code: 'JO',
		label: 'Jordan (JO)',
		countryWithCode: 'Jordan (JO) - 962',
	},
	{
		value: 'Kazakhstan',
		dialCode: 77,
		code: 'KZ',
		label: 'Kazakhstan (KZ)',
		countryWithCode: 'Kazakhstan (KZ) - 77',
	},
	{
		value: 'Kenya',
		dialCode: 254,
		code: 'KE',
		label: 'Kenya (KE)',
		countryWithCode: 'Kenya (KE) - 254',
	},
	{
		value: 'Kiribati',
		dialCode: 686,
		code: 'KI',
		label: 'Kiribati (KI)',
		countryWithCode: 'Kiribati (KI) - 686',
	},
	{
		value: "Korea, Democratic People's Republic of Korea",
		dialCode: 850,
		code: 'KP',
		label: "Korea, Democratic People's Republic of Korea (KP)",
		countryWithCode:
			"Korea, Democratic People's Republic of Korea (KP) - 850",
	},
	{
		value: 'Korea, Republic of South Korea',
		dialCode: 82,
		code: 'KR',
		label: 'Korea, Republic of South Korea (KR)',
		countryWithCode: 'Korea, Republic of South Korea (KR) - 82',
	},
	{
		value: 'Kuwait',
		dialCode: 965,
		code: 'KW',
		label: 'Kuwait (KW)',
		countryWithCode: 'Kuwait (KW) - 965',
	},
	{
		value: 'Kyrgyzstan',
		dialCode: 996,
		code: 'KG',
		label: 'Kyrgyzstan (KG)',
		countryWithCode: 'Kyrgyzstan (KG) - 996',
	},
	{
		value: 'Laos',
		dialCode: 856,
		code: 'LA',
		label: 'Laos (LA)',
		countryWithCode: 'Laos (LA) - 856',
	},
	{
		value: 'Latvia',
		dialCode: 371,
		code: 'LV',
		label: 'Latvia (LV)',
		countryWithCode: 'Latvia (LV) - 371',
	},
	{
		value: 'Lebanon',
		dialCode: 961,
		code: 'LB',
		label: 'Lebanon (LB)',
		countryWithCode: 'Lebanon (LB) - 961',
	},
	{
		value: 'Lesotho',
		dialCode: 266,
		code: 'LS',
		label: 'Lesotho (LS)',
		countryWithCode: 'Lesotho (LS) - 266',
	},
	{
		value: 'Liberia',
		dialCode: 231,
		code: 'LR',
		label: 'Liberia (LR)',
		countryWithCode: 'Liberia (LR) - 231',
	},
	{
		value: 'Libyan Arab Jamahiriya',
		dialCode: 218,
		code: 'LY',
		label: 'Libyan Arab Jamahiriya (LY)',
		countryWithCode: 'Libyan Arab Jamahiriya (LY) - 218',
	},
	{
		value: 'Liechtenstein',
		dialCode: 423,
		code: 'LI',
		label: 'Liechtenstein (LI)',
		countryWithCode: 'Liechtenstein (LI) - 423',
	},
	{
		value: 'Lithuania',
		dialCode: 370,
		code: 'LT',
		label: 'Lithuania (LT)',
		countryWithCode: 'Lithuania (LT) - 370',
	},
	{
		value: 'Luxembourg',
		dialCode: 352,
		code: 'LU',
		label: 'Luxembourg (LU)',
		countryWithCode: 'Luxembourg (LU) - 352',
	},
	{
		value: 'Macao',
		dialCode: 853,
		code: 'MO',
		label: 'Macao (MO)',
		countryWithCode: 'Macao (MO) - 853',
	},
	{
		value: 'Macedonia',
		dialCode: 389,
		code: 'MK',
		label: 'Macedonia (MK)',
		countryWithCode: 'Macedonia (MK) - 389',
	},
	{
		value: 'Madagascar',
		dialCode: 261,
		code: 'MG',
		label: 'Madagascar (MG)',
		countryWithCode: 'Madagascar (MG) - 261',
	},
	{
		value: 'Malawi',
		dialCode: 265,
		code: 'MW',
		label: 'Malawi (MW)',
		countryWithCode: 'Malawi (MW) - 265',
	},
	{
		value: 'Malaysia',
		dialCode: 60,
		code: 'MY',
		label: 'Malaysia (MY)',
		countryWithCode: 'Malaysia (MY) - 60',
	},
	{
		value: 'Maldives',
		dialCode: 960,
		code: 'MV',
		label: 'Maldives (MV)',
		countryWithCode: 'Maldives (MV) - 960',
	},
	{
		value: 'Mali',
		dialCode: 223,
		code: 'ML',
		label: 'Mali (ML)',
		countryWithCode: 'Mali (ML) - 223',
	},
	{
		value: 'Malta',
		dialCode: 356,
		code: 'MT',
		label: 'Malta (MT)',
		countryWithCode: 'Malta (MT) - 356',
	},
	{
		value: 'Marshall Islands',
		dialCode: 692,
		code: 'MH',
		label: 'Marshall Islands (MH)',
		countryWithCode: 'Marshall Islands (MH) - 692',
	},
	{
		value: 'Martinique',
		dialCode: 596,
		code: 'MQ',
		label: 'Martinique (MQ)',
		countryWithCode: 'Martinique (MQ) - 596',
	},
	{
		value: 'Mauritania',
		dialCode: 222,
		code: 'MR',
		label: 'Mauritania (MR)',
		countryWithCode: 'Mauritania (MR) - 222',
	},
	{
		value: 'Mauritius',
		dialCode: 230,
		code: 'MU',
		label: 'Mauritius (MU)',
		countryWithCode: 'Mauritius (MU) - 230',
	},
	{
		value: 'Mayotte',
		dialCode: 262,
		code: 'YT',
		label: 'Mayotte (YT)',
		countryWithCode: 'Mayotte (YT) - 262',
	},
	{
		value: 'Mexico',
		dialCode: 52,
		code: 'MX',
		label: 'Mexico (MX)',
		countryWithCode: 'Mexico (MX) - 52',
	},
	{
		value: 'Micronesia, Federated States of Micronesia',
		dialCode: 691,
		code: 'FM',
		label: 'Micronesia, Federated States of Micronesia (FM)',
		countryWithCode:
			'Micronesia, Federated States of Micronesia (FM) - 691',
	},
	{
		value: 'Moldova',
		dialCode: 373,
		code: 'MD',
		label: 'Moldova (MD)',
		countryWithCode: 'Moldova (MD) - 373',
	},
	{
		value: 'Monaco',
		dialCode: 377,
		code: 'MC',
		label: 'Monaco (MC)',
		countryWithCode: 'Monaco (MC) - 377',
	},
	{
		value: 'Mongolia',
		dialCode: 976,
		code: 'MN',
		label: 'Mongolia (MN)',
		countryWithCode: 'Mongolia (MN) - 976',
	},
	{
		value: 'Montenegro',
		dialCode: 382,
		code: 'ME',
		label: 'Montenegro (ME)',
		countryWithCode: 'Montenegro (ME) - 382',
	},
	{
		value: 'Montserrat',
		dialCode: 1664,
		code: 'MS',
		label: 'Montserrat (MS)',
		countryWithCode: 'Montserrat (MS) - 1664',
	},
	{
		value: 'Morocco',
		dialCode: 212,
		code: 'MA',
		label: 'Morocco (MA)',
		countryWithCode: 'Morocco (MA) - 212',
	},
	{
		value: 'Mozambique',
		dialCode: 258,
		code: 'MZ',
		label: 'Mozambique (MZ)',
		countryWithCode: 'Mozambique (MZ) - 258',
	},
	{
		value: 'Myanmar',
		dialCode: 95,
		code: 'MM',
		label: 'Myanmar (MM)',
		countryWithCode: 'Myanmar (MM) - 95',
	},
	{
		value: 'Namibia',
		dialCode: 264,
		code: 'NA',
		label: 'Namibia (NA)',
		countryWithCode: 'Namibia (NA) - 264',
	},
	{
		value: 'Nauru',
		dialCode: 674,
		code: 'NR',
		label: 'Nauru (NR)',
		countryWithCode: 'Nauru (NR) - 674',
	},
	{
		value: 'Nepal',
		dialCode: 977,
		code: 'NP',
		label: 'Nepal (NP)',
		countryWithCode: 'Nepal (NP) - 977',
	},
	{
		value: 'Netherlands',
		dialCode: 31,
		code: 'NL',
		label: 'Netherlands (NL)',
		countryWithCode: 'Netherlands (NL) - 31',
	},
	{
		value: 'Netherlands Antilles',
		dialCode: 599,
		code: 'AN',
		label: 'Netherlands Antilles (AN)',
		countryWithCode: 'Netherlands Antilles (AN) - 599',
	},
	{
		value: 'New Caledonia',
		dialCode: 687,
		code: 'NC',
		label: 'New Caledonia (NC)',
		countryWithCode: 'New Caledonia (NC) - 687',
	},
	{
		value: 'New Zealand',
		dialCode: 64,
		code: 'NZ',
		label: 'New Zealand (NZ)',
		countryWithCode: 'New Zealand (NZ) - 64',
	},
	{
		value: 'Nicaragua',
		dialCode: 505,
		code: 'NI',
		label: 'Nicaragua (NI)',
		countryWithCode: 'Nicaragua (NI) - 505',
	},
	{
		value: 'Niger',
		dialCode: 227,
		code: 'NE',
		label: 'Niger (NE)',
		countryWithCode: 'Niger (NE) - 227',
	},
	{
		value: 'Nigeria',
		dialCode: 234,
		code: 'NG',
		label: 'Nigeria (NG)',
		countryWithCode: 'Nigeria (NG) - 234',
	},
	{
		value: 'Niue',
		dialCode: 683,
		code: 'NU',
		label: 'Niue (NU)',
		countryWithCode: 'Niue (NU) - 683',
	},
	{
		value: 'Norfolk Island',
		dialCode: 672,
		code: 'NF',
		label: 'Norfolk Island (NF)',
		countryWithCode: 'Norfolk Island (NF) - 672',
	},
	{
		value: 'Northern Mariana Islands',
		dialCode: 1670,
		code: 'MP',
		label: 'Northern Mariana Islands (MP)',
		countryWithCode: 'Northern Mariana Islands (MP) - 1670',
	},
	{
		value: 'Norway',
		dialCode: 47,
		code: 'NO',
		label: 'Norway (NO)',
		countryWithCode: 'Norway (NO) - 47',
	},
	{
		value: 'Oman',
		dialCode: 968,
		code: 'OM',
		label: 'Oman (OM)',
		countryWithCode: 'Oman (OM) - 968',
	},
	{
		value: 'Pakistan',
		dialCode: 92,
		code: 'PK',
		label: 'Pakistan (PK)',
		countryWithCode: 'Pakistan (PK) - 92',
	},
	{
		value: 'Palau',
		dialCode: 680,
		code: 'PW',
		label: 'Palau (PW)',
		countryWithCode: 'Palau (PW) - 680',
	},
	{
		value: 'Palestinian Territory, Occupied',
		dialCode: 970,
		code: 'PS',
		label: 'Palestinian Territory, Occupied (PS)',
		countryWithCode: 'Palestinian Territory, Occupied (PS) - 970',
	},
	{
		value: 'Panama',
		dialCode: 507,
		code: 'PA',
		label: 'Panama (PA)',
		countryWithCode: 'Panama (PA) - 507',
	},
	{
		value: 'Papua New Guinea',
		dialCode: 675,
		code: 'PG',
		label: 'Papua New Guinea (PG)',
		countryWithCode: 'Papua New Guinea (PG) - 675',
	},
	{
		value: 'Paraguay',
		dialCode: 595,
		code: 'PY',
		label: 'Paraguay (PY)',
		countryWithCode: 'Paraguay (PY) - 595',
	},
	{
		value: 'Peru',
		dialCode: 51,
		code: 'PE',
		label: 'Peru (PE)',
		countryWithCode: 'Peru (PE) - 51',
	},
	{
		value: 'Philippines',
		dialCode: 63,
		code: 'PH',
		label: 'Philippines (PH)',
		countryWithCode: 'Philippines (PH) - 63',
	},
	{
		value: 'Pitcairn',
		dialCode: 872,
		code: 'PN',
		label: 'Pitcairn (PN)',
		countryWithCode: 'Pitcairn (PN) - 872',
	},
	{
		value: 'Poland',
		dialCode: 48,
		code: 'PL',
		label: 'Poland (PL)',
		countryWithCode: 'Poland (PL) - 48',
	},
	{
		value: 'Portugal',
		dialCode: 351,
		code: 'PT',
		label: 'Portugal (PT)',
		countryWithCode: 'Portugal (PT) - 351',
	},
	{
		value: 'Puerto Rico',
		dialCode: 1939,
		code: 'PR',
		label: 'Puerto Rico (PR)',
		countryWithCode: 'Puerto Rico (PR) - 1939',
	},
	{
		value: 'Qatar',
		dialCode: 974,
		code: 'QA',
		label: 'Qatar (QA)',
		countryWithCode: 'Qatar (QA) - 974',
	},
	{
		value: 'Romania',
		dialCode: 40,
		code: 'RO',
		label: 'Romania (RO)',
		countryWithCode: 'Romania (RO) - 40',
	},
	{
		value: 'Russia',
		dialCode: 7,
		code: 'RU',
		label: 'Russia (RU)',
		countryWithCode: 'Russia (RU) - 7',
	},
	{
		value: 'Rwanda',
		dialCode: 250,
		code: 'RW',
		label: 'Rwanda (RW)',
		countryWithCode: 'Rwanda (RW) - 250',
	},
	{
		value: 'Reunion',
		dialCode: 262,
		code: 'RE',
		label: 'Reunion (RE)',
		countryWithCode: 'Reunion (RE) - 262',
	},
	{
		value: 'Saint Barthelemy',
		dialCode: 590,
		code: 'BL',
		label: 'Saint Barthelemy (BL)',
		countryWithCode: 'Saint Barthelemy (BL) - 590',
	},
	{
		value: 'Saint Helena, Ascension and Tristan Da Cunha',
		dialCode: 290,
		code: 'SH',
		label: 'Saint Helena, Ascension and Tristan Da Cunha (SH)',
		countryWithCode:
			'Saint Helena, Ascension and Tristan Da Cunha (SH) - 290',
	},
	{
		value: 'Saint Kitts and Nevis',
		dialCode: 1869,
		code: 'KN',
		label: 'Saint Kitts and Nevis (KN)',
		countryWithCode: 'Saint Kitts and Nevis (KN) - 1869',
	},
	{
		value: 'Saint Lucia',
		dialCode: 1758,
		code: 'LC',
		label: 'Saint Lucia (LC)',
		countryWithCode: 'Saint Lucia (LC) - 1758',
	},
	{
		value: 'Saint Martin',
		dialCode: 590,
		code: 'MF',
		label: 'Saint Martin (MF)',
		countryWithCode: 'Saint Martin (MF) - 590',
	},
	{
		value: 'Saint Pierre and Miquelon',
		dialCode: 508,
		code: 'PM',
		label: 'Saint Pierre and Miquelon (PM)',
		countryWithCode: 'Saint Pierre and Miquelon (PM) - 508',
	},
	{
		value: 'Saint Vincent and the Grenadines',
		dialCode: 1784,
		code: 'VC',
		label: 'Saint Vincent and the Grenadines (VC)',
		countryWithCode: 'Saint Vincent and the Grenadines (VC) - 1784',
	},
	{
		value: 'Samoa',
		dialCode: 685,
		code: 'WS',
		label: 'Samoa (WS)',
		countryWithCode: 'Samoa (WS) - 685',
	},
	{
		value: 'San Marino',
		dialCode: 378,
		code: 'SM',
		label: 'San Marino (SM)',
		countryWithCode: 'San Marino (SM) - 378',
	},
	{
		value: 'Sao Tome and Principe',
		dialCode: 239,
		code: 'ST',
		label: 'Sao Tome and Principe (ST)',
		countryWithCode: 'Sao Tome and Principe (ST) - 239',
	},
	{
		value: 'Saudi Arabia',
		dialCode: 966,
		code: 'SA',
		label: 'Saudi Arabia (SA)',
		countryWithCode: 'Saudi Arabia (SA) - 966',
	},
	{
		value: 'Senegal',
		dialCode: 221,
		code: 'SN',
		label: 'Senegal (SN)',
		countryWithCode: 'Senegal (SN) - 221',
	},
	{
		value: 'Serbia',
		dialCode: 381,
		code: 'RS',
		label: 'Serbia (RS)',
		countryWithCode: 'Serbia (RS) - 381',
	},
	{
		value: 'Seychelles',
		dialCode: 248,
		code: 'SC',
		label: 'Seychelles (SC)',
		countryWithCode: 'Seychelles (SC) - 248',
	},
	{
		value: 'Sierra Leone',
		dialCode: 232,
		code: 'SL',
		label: 'Sierra Leone (SL)',
		countryWithCode: 'Sierra Leone (SL) - 232',
	},
	{
		value: 'Singapore',
		dialCode: 65,
		code: 'SG',
		label: 'Singapore (SG)',
		countryWithCode: 'Singapore (SG) - 65',
	},
	{
		value: 'Slovakia',
		dialCode: 421,
		code: 'SK',
		label: 'Slovakia (SK)',
		countryWithCode: 'Slovakia (SK) - 421',
	},
	{
		value: 'Slovenia',
		dialCode: 386,
		code: 'SI',
		label: 'Slovenia (SI)',
		countryWithCode: 'Slovenia (SI) - 386',
	},
	{
		value: 'Solomon Islands',
		dialCode: 677,
		code: 'SB',
		label: 'Solomon Islands (SB)',
		countryWithCode: 'Solomon Islands (SB) - 677',
	},
	{
		value: 'Somalia',
		dialCode: 252,
		code: 'SO',
		label: 'Somalia (SO)',
		countryWithCode: 'Somalia (SO) - 252',
	},
	{
		value: 'South Africa',
		dialCode: 27,
		code: 'ZA',
		label: 'South Africa (ZA)',
		countryWithCode: 'South Africa (ZA) - 27',
	},
	{
		value: 'South Sudan',
		dialCode: 211,
		code: 'SS',
		label: 'South Sudan (SS)',
		countryWithCode: 'South Sudan (SS) - 211',
	},
	{
		value: 'South Georgia and the South Sandwich Islands',
		dialCode: 500,
		code: 'GS',
		label: 'South Georgia and the South Sandwich Islands (GS)',
		countryWithCode:
			'South Georgia and the South Sandwich Islands (GS) - 500',
	},
	{
		value: 'Spain',
		dialCode: 34,
		code: 'ES',
		label: 'Spain (ES)',
		countryWithCode: 'Spain (ES) - 34',
	},
	{
		value: 'Sri Lanka',
		dialCode: 94,
		code: 'LK',
		label: 'Sri Lanka (LK)',
		countryWithCode: 'Sri Lanka (LK) - 94',
	},
	{
		value: 'Sudan',
		dialCode: 249,
		code: 'SD',
		label: 'Sudan (SD)',
		countryWithCode: 'Sudan (SD) - 249',
	},
	{
		value: 'Suriname',
		dialCode: 597,
		code: 'SR',
		label: 'Suriname (SR)',
		countryWithCode: 'Suriname (SR) - 597',
	},
	{
		value: 'Svalbard and Jan Mayen',
		dialCode: 47,
		code: 'SJ',
		label: 'Svalbard and Jan Mayen (SJ)',
		countryWithCode: 'Svalbard and Jan Mayen (SJ) - 47',
	},
	{
		value: 'Swaziland',
		dialCode: 268,
		code: 'SZ',
		label: 'Swaziland (SZ)',
		countryWithCode: 'Swaziland (SZ) - 268',
	},
	{
		value: 'Sweden',
		dialCode: 46,
		code: 'SE',
		label: 'Sweden (SE)',
		countryWithCode: 'Sweden (SE) - 46',
	},
	{
		value: 'Switzerland',
		dialCode: 41,
		code: 'CH',
		label: 'Switzerland (CH)',
		countryWithCode: 'Switzerland (CH) - 41',
	},
	{
		value: 'Syrian Arab Republic',
		dialCode: 963,
		code: 'SY',
		label: 'Syrian Arab Republic (SY)',
		countryWithCode: 'Syrian Arab Republic (SY) - 963',
	},
	{
		value: 'Taiwan',
		dialCode: 886,
		code: 'TW',
		label: 'Taiwan (TW)',
		countryWithCode: 'Taiwan (TW) - 886',
	},
	{
		value: 'Tajikistan',
		dialCode: 992,
		code: 'TJ',
		label: 'Tajikistan (TJ)',
		countryWithCode: 'Tajikistan (TJ) - 992',
	},
	{
		value: 'Tanzania, United Republic of Tanzania',
		dialCode: 255,
		code: 'TZ',
		label: 'Tanzania, United Republic of Tanzania (TZ)',
		countryWithCode: 'Tanzania, United Republic of Tanzania (TZ) - 255',
	},
	{
		value: 'Thailand',
		dialCode: 66,
		code: 'TH',
		label: 'Thailand (TH)',
		countryWithCode: 'Thailand (TH) - 66',
	},
	{
		value: 'Timor-Leste',
		dialCode: 670,
		code: 'TL',
		label: 'Timor-Leste (TL)',
		countryWithCode: 'Timor-Leste (TL) - 670',
	},
	{
		value: 'Togo',
		dialCode: 228,
		code: 'TG',
		label: 'Togo (TG)',
		countryWithCode: 'Togo (TG) - 228',
	},
	{
		value: 'Tokelau',
		dialCode: 690,
		code: 'TK',
		label: 'Tokelau (TK)',
		countryWithCode: 'Tokelau (TK) - 690',
	},
	{
		value: 'Tonga',
		dialCode: 676,
		code: 'TO',
		label: 'Tonga (TO)',
		countryWithCode: 'Tonga (TO) - 676',
	},
	{
		value: 'Trinidad and Tobago',
		dialCode: 1868,
		code: 'TT',
		label: 'Trinidad and Tobago (TT)',
		countryWithCode: 'Trinidad and Tobago (TT) - 1868',
	},
	{
		value: 'Tunisia',
		dialCode: 216,
		code: 'TN',
		label: 'Tunisia (TN)',
		countryWithCode: 'Tunisia (TN) - 216',
	},
	{
		value: 'Turkey',
		dialCode: 90,
		code: 'TR',
		label: 'Turkey (TR)',
		countryWithCode: 'Turkey (TR) - 90',
	},
	{
		value: 'Turkmenistan',
		dialCode: 993,
		code: 'TM',
		label: 'Turkmenistan (TM)',
		countryWithCode: 'Turkmenistan (TM) - 993',
	},
	{
		value: 'Turks and Caicos Islands',
		dialCode: 1649,
		code: 'TC',
		label: 'Turks and Caicos Islands (TC)',
		countryWithCode: 'Turks and Caicos Islands (TC) - 1649',
	},
	{
		value: 'Tuvalu',
		dialCode: 688,
		code: 'TV',
		label: 'Tuvalu (TV)',
		countryWithCode: 'Tuvalu (TV) - 688',
	},
	{
		value: 'Uganda',
		dialCode: 256,
		code: 'UG',
		label: 'Uganda (UG)',
		countryWithCode: 'Uganda (UG) - 256',
	},
	{
		value: 'Ukraine',
		dialCode: 380,
		code: 'UA',
		label: 'Ukraine (UA)',
		countryWithCode: 'Ukraine (UA) - 380',
	},
	{
		value: 'United Arab Emirates',
		dialCode: 971,
		code: 'AE',
		label: 'United Arab Emirates (AE)',
		countryWithCode: 'United Arab Emirates (AE) - 971',
	},
	{
		value: 'United Kingdom',
		dialCode: 44,
		code: 'GB',
		label: 'United Kingdom (GB)',
		countryWithCode: 'United Kingdom (GB) - 44',
	},
	{
		value: 'United States',
		dialCode: 1,
		code: 'US',
		label: 'United States (US)',
		countryWithCode: 'United States (US) - 1',
	},
	{
		value: 'Uruguay',
		dialCode: 598,
		code: 'UY',
		label: 'Uruguay (UY)',
		countryWithCode: 'Uruguay (UY) - 598',
	},
	{
		value: 'Uzbekistan',
		dialCode: 998,
		code: 'UZ',
		label: 'Uzbekistan (UZ)',
		countryWithCode: 'Uzbekistan (UZ) - 998',
	},
	{
		value: 'Vanuatu',
		dialCode: 678,
		code: 'VU',
		label: 'Vanuatu (VU)',
		countryWithCode: 'Vanuatu (VU) - 678',
	},
	{
		value: 'Venezuela, Bolivarian Republic of Venezuela',
		dialCode: 58,
		code: 'VE',
		label: 'Venezuela, Bolivarian Republic of Venezuela (VE)',
		countryWithCode:
			'Venezuela, Bolivarian Republic of Venezuela (VE) - 58',
	},
	{
		value: 'Vietnam',
		dialCode: 84,
		code: 'VN',
		label: 'Vietnam (VN)',
		countryWithCode: 'Vietnam (VN) - 84',
	},
	{
		value: 'Virgin Islands, British',
		dialCode: 1284,
		code: 'VG',
		label: 'Virgin Islands, British (VG)',
		countryWithCode: 'Virgin Islands, British (VG) - 1284',
	},
	{
		value: 'Virgin Islands, U.S.',
		dialCode: 1340,
		code: 'VI',
		label: 'Virgin Islands, U.S. (VI)',
		countryWithCode: 'Virgin Islands, U.S. (VI) - 1340',
	},
	{
		value: 'Wallis and Futuna',
		dialCode: 681,
		code: 'WF',
		label: 'Wallis and Futuna (WF)',
		countryWithCode: 'Wallis and Futuna (WF) - 681',
	},
	{
		value: 'Yemen',
		dialCode: 967,
		code: 'YE',
		label: 'Yemen (YE)',
		countryWithCode: 'Yemen (YE) - 967',
	},
	{
		value: 'Zambia',
		dialCode: 260,
		code: 'ZM',
		label: 'Zambia (ZM)',
		countryWithCode: 'Zambia (ZM) - 260',
	},
	{
		value: 'Zimbabwe',
		dialCode: 263,
		code: 'ZW',
		label: 'Zimbabwe (ZW)',
		countryWithCode: 'Zimbabwe (ZW) - 263',
	},
];

const mathOptions = [
	{value: "Kashi math", label: "Kashi math"},
	{value: "Gokarna math", label: "Gokarna math"},
	{value: "Kavale math", label: "Kavale math"},
	{value: "Chitrapur math", label: "Chitrapur math"},
	{value: "Other", label: "Other"},
]

export const MIN_AGE = 18;
export const MAX_AGE = 60;

export const GenerateAgeOptions = (minAge, maxAge)  => {
	var optionList = []
	for(var index = minAge; index <=maxAge; index++)
		optionList.push({value: index, label: `${index} years`})
	return optionList;
}

export const MIN_HT_CM = 91.44;
export const MAX_HT_CM = 241.3;

// Helper function to convert cm to feet and inches
export const cmToFeetInchesObject = (cm) => {
	const totalInches = Math.round(cm / 2.54);
	const feet = Math.floor(totalInches / 12);
	const inches = totalInches % 12;
	return { feet, inches };
};

// returns allowed feet and inch options inclusive of min, max
export const GenerateHeightOptions = (minCm, maxCm) => {
    var heightOptions = {}; // { 3: [0,1,2..], 4: [0,1...]}. Keys of object are available feet options and and value are allowed inch options.

    // Convert min and max cm to feet and inches
    const minHeight = cmToFeetInchesObject(minCm);
    const maxHeight = cmToFeetInchesObject(maxCm);

    // Loop through feet from min to max
    for (let ft = minHeight.feet; ft <= maxHeight.feet; ft++) {
        let startInches = (ft === minHeight.feet) ? minHeight.inches : 0;
        let endInches = (ft === maxHeight.feet) ? maxHeight.inches : 11;

        heightOptions[ft] = [];
        for (let inch = startInches; inch <= endInches; inch++) {
            heightOptions[ft].push(inch);
        }
    }

    return heightOptions;
};

export {
	qualificationOptions,
	occupationOptions,
	annualIncomeOptions,
	maritalStatusOptions,
	religionOptions,
	casteOptions,
	motherTongueOptions,
	languageOptions,
	rashiOptions,
	bloodGroupOptions,
	foodHabitsOptions,
	drinkingHabitsOptions,
	smokingHabitsOptions,
	nakshatraOptions,
	complexionOptions,
	kuldevataOptions,
	gotraOptions,
	heightOptions,
	rashiHindiOptions,
	stateOptions,
	countryOptions,
	feetOptions,
	inchOptions,
	mathOptions
};
